import type { DtsInboundConnectorDto } from '@dhl/mdp-api'
import { InboundKafka } from '~/modules/ppp/submodules/relations/components/inbound/InboundKafka'
import { DataWrapper } from '~/modules/ppp/submodules/relations/components/data'
import { InboundApi } from '~/modules/ppp/submodules/relations/components/inbound/InboundApi'
import { InboundSftp } from '~/modules/ppp/submodules/relations/components/inbound/InboundSftp'

type Props = {
  connector: DtsInboundConnectorDto
}

export const InboundConnector = ({ connector }: Props) => (
  <DataWrapper>
    {connector.API && <InboundApi config={connector.API} />}
    {connector.Kafka && <InboundKafka config={connector.Kafka} />}
    {connector.SFTP && <InboundSftp config={connector.SFTP} />}
  </DataWrapper>
)
